module.exports = __webpack_public_path__ + "static/media/资源一号02C星.32dcb60a.png";